module.exports = __webpack_public_path__ + "img/pitch.8a7b02d8.png";